import { render, staticRenderFns } from "./IdAndAccount.vue?vue&type=template&id=5874dcc2&scoped=true"
import script from "./IdAndAccount.vue?vue&type=script&lang=js"
export * from "./IdAndAccount.vue?vue&type=script&lang=js"
import style0 from "./IdAndAccount.vue?vue&type=style&index=0&id=5874dcc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5874dcc2",
  null
  
)

export default component.exports